<template>
  <div class="min-h-screen flex flex-col text-primary-100 bg-head-office-20">
    <CorporateNavigation />

    <main id="content" class="md:pt-10 pb-24 md:pb-50 overflow-clip">
      <slot />
    </main>

    <CorporateFooter v-bind="layoutData" class="mt-auto" />
  </div>
</template>

<script setup lang="ts">
import CorporateFooter from '@corporate/components/Footer/CorporateFooter.vue'
import CorporateNavigation from '@corporate/components/Navigation/CorporateNavigation.vue'
import { useLayoutData } from '@corporate/composables/use-layout'
import { inject, computed } from 'vue'

const layoutData = useLayoutData()

// Detect if this is a subhome page (corporateSubhome type)

const isSubhomePage = computed(() => {
  // Check if the page type is corporateSubhome

  const pageData = inject('pageData') as { value?: { type?: string } } | null

  return pageData?.value?.type === 'corporateSubhome'
})
</script>

